import { css } from '@emotion/react';

const DEFAULT_SHADOW_HEIGHT = '0.75rem';
const TABLE_SHADOW_HEIGHT_ABOVE = '50px';
const TABLE_SHADOW_HEIGHT_BELOW = '15px';

const styles = {
	defaultShadow: (side: 'top' | 'bottom') =>
		css(
			{ position: 'absolute', display: 'block', pointerEvents: 'none' },
			{
				height: DEFAULT_SHADOW_HEIGHT,
				left: 0,
				right: 0,
				[side]: `-${DEFAULT_SHADOW_HEIGHT}`,
				backgroundImage: `linear-gradient(to ${side}, #00000015, #00000000)`,
			}
		),
	tableShadowAbove: (side: 'top' | 'bottom') =>
		css(
			{ position: 'absolute', display: 'block', pointerEvents: 'none' },
			{
				height: TABLE_SHADOW_HEIGHT_ABOVE,
				left: 0,
				right: 0,
				[side]: `-${TABLE_SHADOW_HEIGHT_ABOVE}`,
				opacity: '',
				backgroundImage: `linear-gradient(to ${
					side === 'top' ? 'bottom' : 'top'
				}, #00000000 55.87%, #E5FAFE 100%)`,
			}
		),
	tableShadowBelow: (side: 'top' | 'bottom') =>
		css(
			{ position: 'absolute', display: 'block', pointerEvents: 'none' },
			{
				height: TABLE_SHADOW_HEIGHT_BELOW,
				left: 0,
				right: 0,
				[side]: '0px',
				backgroundImage: `linear-gradient(to ${
					side === 'top' ? 'bottom' : 'top'
				}, #FBFEFF, #F9FEFF 10.87%, #00000000 99%)`,
			}
		),
};

export interface EdgeShadowProps {
	side: 'top' | 'bottom';
	as?: 'td' | 'div';
	shadowType?: 'default' | 'table-row';
}

export function EdgeShadow({
	side,
	as: Component = 'div',
	shadowType = 'default',
}: EdgeShadowProps) {
	return shadowType === 'table-row' ? (
		<>
			<Component role="presentation" css={styles.tableShadowAbove(side)} />
			<Component role="presentation" css={styles.tableShadowBelow(side)} />
		</>
	) : (
		<Component role="presentation" css={styles.defaultShadow(side)} />
	);
}
